import React, { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import ThemeToggle from './ThemeToggle';
import img from '../assets/images/loggoo.png';

import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const { theme } = useContext(ThemeContext);
    const navigate=useNavigate()
  const handleNavigate=()=>{
    navigate('/login')
  }
    return (
        <nav className={`bg-slate shadow ${theme === 'dark' ? 'bg-black shadow-gray-700' : 'bg-gray-900 shadow-blue-200'} border-gray-200 text-center`}>
            <div className='flex justify-between items-center mx-auto'>
                {/* <div className='flex justify-end items-end ml-10 mt-3'>
                    <ThemeToggle />
                </div> */}
                <div className='flex items-center mx-auto justify-center'>
                    <img onClick={handleNavigate}
                        src={img} 
                        className='w-[100px] h-[100px] cursor-pointer text-xl font-bold py-4 font-serif text-white lg:mr-0 mr-24' 
                        // className='w-[100px] h-[90px] cursor-pointer animate-slow-bounce text-xl font-bold pt-6 font-serif text-white lg:ml-24 lg:mr-0 mr-24' 
                    />
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
